import { useSelector } from 'react-redux';
import { mapSharedState } from 'app/infrastructure/redux/container-factory';
import { createSelector } from '@reduxjs/toolkit';

export const useSharedState = () => {
  return useSelector(createSelector([state => state.app], state => mapSharedState(state) ));
};
